// The logger is initialised by importing it, so it must come before any module
// that might log while it is being evaluated (GUIDELINES.md §4).
import "@/lib/logger";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
